import React from 'react'
import { Button, ButtonProps, CircularProgress } from '@mui/material'

interface IProps extends ButtonProps {
  text: string
  loading?: boolean
}

export const TransitionButton: React.FC<IProps> = ({
  text,
  loading,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        ...props.sx,
        borderRadius: 4
      }}
    >
      {loading && <CircularProgress size="1.3rem" color="primary" />}
      {!loading && text}
    </Button>
  )
}
